import React, {useCallback, useState} from 'react';
import DashboardMain_Orion from '../DashboardMain_Orion/DashboardMain_Orion';
import SecondPageFilterSection_Orion from './FaultSecondPage_Orion/SecondPageFilterSection_Orion';
import SecondPageDataSection_Orion from './FaultSecondPage_Orion/SecondPageDataSection_Orion';
import SecondPageFirstGraph_Orion from './FaultSecondPage_Orion/SecondPageFirstGraph_Orion';
import SecondPageSecondGraph_Orion from './FaultSecondPage_Orion/SecondPageSecondGraph_Orion';


export default function FaultSingleVinAnalysis_Orion(props){

    const [secondPageState, setSecondPageState] = useState({
        startDate: props.gloablfilter.startDate,
        endDate: props.gloablfilter.endDate,
        vin_num: props.gloablfilter.VIN_NUM.toString(),
        CITY: props.gloablfilter.CITY,
        DEPO: props.gloablfilter.DEPO,
    });

    const filterSubmited = useCallback((data) => {
        setSecondPageState(data);
    }, []);

    const onreset = (data) => {
        setSecondPageState({
            startDate: props.gloablfilter.startDate,
            endDate: props.gloablfilter.endDate,
            vin_num: "",
            CITY: props.gloablfilter.CITY,
            DEPO: props.gloablfilter.DEPO,
        });
    }

    return(
        <>        
        <DashboardMain_Orion >
            <SecondPageFilterSection_Orion onsubmit={filterSubmited} secondPageState={secondPageState} onreset={onreset} />
            <div className="container-fluid busdrpg1">
                <section className="graphs sec2Charts">
                    {/* <FaultSecondPageDataBars_Bus gloablfilter={secondPageState} /> */}
                    <SecondPageDataSection_Orion gloablfilter={secondPageState} />
                    <div className="row mt-4 equal-cols">
                        <SecondPageFirstGraph_Orion gloablfilter={secondPageState}/>
                        <SecondPageSecondGraph_Orion gloablfilter={secondPageState}/>
                        {/* <SecondPageSecondGraph gloablfilter={secondPageState}/> */}
                    </div>
                </section>
            </div>
        </DashboardMain_Orion>
        </>
    )
}